import {
  TRACK_START_PLAYING, TRACK_STOP_PLAYING, TRACK_PAUSE_PLAYING, TRACK_RESUME_PLAYING,
} from '../reducers/player';

export const trackStartPlaying = (id) => ({ type: TRACK_START_PLAYING, payload: { id } });
export const trackPausePlaying = () => ({ type: TRACK_PAUSE_PLAYING });
export const trackResumePlaying = () => ({ type: TRACK_RESUME_PLAYING });
export const trackStopPlaying = () => ({ type: TRACK_STOP_PLAYING });
